import React, { useMemo } from 'react';
import Button from 'devextreme-react/button';

export function CompetitionEntries({ data, stats, onImport, onSend }) {
  const mergedStats = useMemo(() => {
    if (data) {
      return {
        clubs: data.clubs?.length || 0,
        athletes: data.athletes?.length || 0,
        entries: data.results?.length || 0,
        relays: data.athletes?.filter(a => a.isRelay)?.length || 0,
        ...stats
      };
    }
    return {
      clubs: 0,
      athletes: 0,
      entries: 0,
      relays: 0,
      ...stats
    };
  }, [data, stats]);

  return (
    <div className='competition-section'>
      <div className='section-header'>
        <div>
          <div className='section-title'>Meldungen</div>
          <div className='section-subtitle'>Eingegangene Meldungen und nächste Schritte</div>
        </div>
        <div className='section-pill subtle'>intern</div>
      </div>

      <div className='stats-grid'>
        <div className='stat-card'>
          <div className='stat-number'>{mergedStats.clubs}</div>
          <div className='stat-label'>Vereine</div>
        </div>
        <div className='stat-card'>
          <div className='stat-number'>{mergedStats.athletes}</div>
          <div className='stat-label'>Sportler</div>
        </div>
        <div className='stat-card'>
          <div className='stat-number'>{mergedStats.entries}</div>
          <div className='stat-label'>Meldepositionen</div>
        </div>
        <div className='stat-card'>
          <div className='stat-number'>{mergedStats.relays}</div>
          <div className='stat-label'>Staffeln</div>
        </div>
      </div>

      <div className='action-row'>
        <Button text='Meldungen importieren' icon='upload' type='normal' stylingMode='outlined' onClick={onImport} />
        <Button text='Meldeergebnis versenden' icon='email' type='default' stylingMode='contained' onClick={onSend} />
      </div>

      <p className='muted-hint'>Funktionen sind vorbereitet – API-Anbindung und Statuswechsel folgen.</p>
    </div>
  );
}
